import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/api";
import { setLoading } from "../../loading/loadingSlice";

export const getAddConsumableList = createAsyncThunk("getAddConsumableList", async ({ page, limit, search }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      search,
      searchFields: "itemName,code",
    };
    const response = await api.get(`/api/v1/cc/nursing_care/additional_consumables`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const editConsumable = createAsyncThunk("editConsumable", async ({ body, userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.patch(`/api/v1/cc/nursing_care/additional_consumables/${userId}`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error updating :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error updating";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const deleteConsumable = createAsyncThunk("deleteConsumable", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.delete(`/api/v1/cc/nursing_care/additional_consumables/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleteing :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error deleteing";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getAllGroups = createAsyncThunk("getAllGroups", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.get(`/api/v1/cc/nursing_care/additional_consumables/groups`);
    return response.data;
  } catch (error) {
    console.error("Error getting list :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const createConsumable = createAsyncThunk("createConsumable", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.post(`/api/v1/cc/nursing_care/additional_consumables`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error creating consumable :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating consumable";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const createGroup = createAsyncThunk("createGroup", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.post(`/api/v1/cc/nursing_care/additional_consumables/groups`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error creating group :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating group";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
